import { TFile } from '@brg/api';
import { RefObject, useEffect, useMemo, useRef, useState } from 'react';

/**
 * Возвращает реф для контейнера, под который нужно подобрать ресайз
 * и выбранный из массива файл
 */

const NARROW_LONGREAD_WIDTH = 778;

export const getImageToWidth = (files: TFile[], targetWidth: number) => {
  const filesSafe = files ? [...files] : [];
  const pixelRatio = window.devicePixelRatio > 2 ? 2 : window.devicePixelRatio

  const { resized } = filesSafe.reduce((result: any, item: any) => {
    const { width } = item;
    if (width >= targetWidth * pixelRatio) {
      return {
        resized: item,
      };
    }
    return result;
  }, {
    resized: null,
  })

  return resized || filesSafe.find(({ size }) => size === 'original');
}

export const useResizedImageEnhanced = (files?: TFile[], fixedSize?: any, showOriginals?: boolean): [TFile?, RefObject<HTMLDivElement>?] => {
  const filesSafe = useMemo(() => files ? [...files] : [], [files]);
  const containerRef = useRef<HTMLDivElement>(null);
  const [container, setContainer] = useState<HTMLDivElement>();
  const containerWidth = fixedSize?.width || container?.offsetWidth;
  const containerHeight = fixedSize?.heigth || container?.offsetHeight;
  const pixelRatio = window.devicePixelRatio > 2 ? 2 : window.devicePixelRatio
  const targetWidth = (containerWidth || 0) * pixelRatio;
  const targetHeight = (containerHeight || 0) * pixelRatio;

  const image = useMemo(() => {
    if (!containerWidth) {
      return null
    }
    const { resized } = filesSafe.reduce((result: any, item: any) => {
      const { width, height } = item;
      const area = width * height;
      const { smallestArea } = result;
      if (width >= targetWidth && height >= targetHeight && (!smallestArea || area < smallestArea)) {
        return {
          resized: item,
          smallestArea: area,
        };
      }
      return result;
    }, {
      smallestArea: 0,
      resized: null,
    })

    const { largest } = filesSafe.reduce((result: any, item: any) => {
      const { width, height } = item;
      const area = width * height;
      const { largestArea } = result;
      if (!largestArea || area > largestArea) {
        return {
          largest: item,
          largestArea: area,
        };
      }
      return result;
    }, {
      largestArea: 0,
      largest: null,
    })

    return showOriginals ? largest : (resized || largest);
  }, [targetWidth, filesSafe, showOriginals]);

  useEffect(() => {
    if (containerRef.current) {
      setContainer(containerRef.current);
    }
  }, []);

  return [image, containerRef];
};
import { TFile } from '@brg/api';
import { RefObject, useEffect, useMemo, useRef, useState } from 'react';

/**
 * Возвращает реф для контейнера, под который нужно подобрать ресайз
 * и выбранный из массива файл
 */

const NARROW_LONGREAD_WIDTH = 778;

export const getImageToWidth = (files: TFile[], targetWidth: number) => {
  const filesSafe = files ? [...files] : [];
  const pixelRatio = window.devicePixelRatio > 2 ? 2 : window.devicePixelRatio

  const { resized } = filesSafe.reduce((result: any, item: any) => {
    const { width } = item;
    if (width >= targetWidth * pixelRatio) {
      return {
        resized: item,
      };
    }
    return result;
  }, {
    resized: null,
  })

  return resized || filesSafe.find(({ size }) => size === 'original');
}

export const useResizedImageEnhanced = (files?: TFile[], fixedSize?: any, showOriginals?: boolean): [TFile?, RefObject<HTMLDivElement>?] => {
  const filesSafe = useMemo(() => files ? [...files] : [], [files]);
  const containerRef = useRef<HTMLDivElement>(null);
  const [container, setContainer] = useState<HTMLDivElement>();
  const containerWidth = fixedSize?.width || container?.offsetWidth;
  const containerHeight = fixedSize?.heigth || container?.offsetHeight;
  const pixelRatio = window.devicePixelRatio > 2 ? 2 : window.devicePixelRatio
  const targetWidth = (containerWidth || 0) * pixelRatio;
  const targetHeight = (containerHeight || 0) * pixelRatio;

  const image = useMemo(() => {
    if (!containerWidth) {
      return null
    }
    const { resized } = filesSafe.reduce((result: any, item: any) => {
      const { width, height } = item;
      const area = width * height;
      const { smallestArea } = result;
      if (width >= targetWidth && height >= targetHeight && (!smallestArea || area < smallestArea)) {
        return {
          resized: item,
          smallestArea: area,
        };
      }
      return result;
    }, {
      smallestArea: 0,
      resized: null,
    })

    const { largest } = filesSafe.reduce((result: any, item: any) => {
      const { width, height } = item;
      const area = width * height;
      const { largestArea } = result;
      if (!largestArea || area > largestArea) {
        return {
          largest: item,
          largestArea: area,
        };
      }
      return result;
    }, {
      largestArea: 0,
      largest: null,
    })

    return showOriginals ? largest : (resized || largest);
  }, [targetWidth, filesSafe, showOriginals]);

  useEffect(() => {
    if (containerRef.current) {
      setContainer(containerRef.current);
    }
  }, []);

  return [image, containerRef];
};
